import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerDotted24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDividerDotted24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 5A1.5 1.5 0 0 1 7 3.5h10A1.5 1.5 0 0 1 18.5 5v2.5a.75.75 0 0 0 1.5 0V5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.5a.75.75 0 0 0 1.5 0zm0 14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5v-2.5a.75.75 0 0 1 1.5 0V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-2.5a.75.75 0 0 1 1.5 0zm0-7A.75.75 0 1 1 4 12a.75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11.5 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M17.5 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerDotted24);
